import DocumentAdd from './DocumentAdd'

const DocumentView = () => <DocumentAdd readOnly />
export default DocumentView
